"use client"
import CommentCard from "@/components/views/venue-details/card/comments/CommentCard";
import { useHeader } from "@/hooks/headerContext";
import { useDataUpdater } from "@/lib/hooks/useApi";
import dynamic from "next/dynamic";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "@/hooks/translationContext";

const AddReplyModal = dynamic(() => import("@/components/views/venue-details/new-details/comments/AddReplyModal"))

interface Props {
    comments: any[];
    pageType: "campaign" | "event" | "company";
}

export default function PageCommentList({ comments, pageType }: Props) {
    const { t } = useTranslation();
    const [parentComment, setParentComment] = useState({} as ParentComment);
    const [showReplyModal, setShowReplyModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const {service, district} = useHeader()

    const handleShowReply = (parent) => {
        setParentComment(parent)
        setShowReplyModal(true)
    }

    const { sendRequest } = useDataUpdater({
        method: "POST",
        path: "comment/page/guest",
    });

    const handleSubmit = async (data): Promise<boolean | number> => {
        const toastId = toast.loading(t("venue-detail-reply-submit-loading"));

        setIsLoading(true);
        try {
            const body = {
                text: data.text,
                parent_id: data.parent_id,
                full_name: data.fullName,
                page_type: pageType
            };

            if (service?.id) body["service_id"] = service.id
            if (district?.id) body["district_id"] = district.id

            const res = await sendRequest(body);
            if (res) {
                toast.success(t("venue-detail-reply-pending-approval-info"), {
                    id: toastId,
                });
                setShowReplyModal(false)
                setParentComment(null)
                return true;
            } else {
                toast.error(t("venue-detail-reply-submit-error"), { id: toastId });
                return false;
            }
        } catch (error) {
            toast.error(t("venue-detail-reply-submit-error"), { id: toastId });
            return false;
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-3 items-start gap-5">
                {comments.map((comment, index) => (
                    <CommentCard
                        handleShowReply={handleShowReply}
                        comment={comment}
                        key={index}
                    />
                ))}
            </div>

            {parentComment && (
                <AddReplyModal isLoading={isLoading} disableRating handleSubmit={handleSubmit} parentComment={parentComment} isOpen={showReplyModal} onClose={() => setShowReplyModal(false)} />
            )}
        </div>
    )
}
